exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "label.fixedWidthLabel {\n  width: 100px; }\n\ndiv.fixedHeight {\n  height: 40px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/modules/networking/networking-vc/gateways/dialogs/add-edit-interface-dialog.scss
// module id = fG02
// module chunks = 0